module.exports = __webpack_public_path__ + "img/funds.9a86728c.svg";